import axios from 'axios'

const BASE_URL = 'http://mobile.gorod.sputnik.systems/api/web/v1/'

class sessionApi {
  static requestHeaders() {
    return { jwt: `Bearer ${localStorage.jwt}` }
  }

  static sendSMS(phone) {
    const url = BASE_URL + 'auth/register'
    return axios.post(url, { phone: phone, platform: 'web' })
  }

  static activatePhone(phone, code) {
    const url = BASE_URL + 'auth/register/confirm'
    return axios.post(url, { phone: phone, sms_code: code, platform: 'web' })
  }

  static logOut() {
    const url = BASE_URL + '/account/register/logout'
    return axios.post(
      url,
      { platform: 'web' },
      { headers: this.requestHeaders() }
    )
  }

  static getVideoData() {
    const url = BASE_URL + 'account/devices/sputnik/video'
    return axios
      .get(url, { headers: this.requestHeaders() })
      .then(response => response)
      .catch(err => err)
  }

  static getAccountSettings() {
    const url = BASE_URL + 'account/settings'
    return axios.get(url, { headers: this.requestHeaders() })
  }

  static setAccountSettings(parameters = {}) {
    const url = BASE_URL + 'account/settings'
    const newparams = { ...parameters, platform: 'web' }
    return axios.put(url, newparams, { headers: this.requestHeaders() })
  }

  static openDoor() {
    const url = BASE_URL + 'account/devices/sputnik/open'
    return axios.post(url, {}, { headers: this.requestHeaders() })
  }

  static sendFeedback(title, text) {
    const url = BASE_URL + 'account/feedback'
    return axios.post(url, { title, text, platform: 'web' }, { headers: this.requestHeaders() })
  }

  static  getActivationCode() {
    const url = BASE_URL + '/account/auth_code'
    return axios.get(url, {headers: this.requestHeaders()})
  }
}

export default sessionApi



// WEBPACK FOOTER //
// ./src/api/sessionApi.js